// extracted by mini-css-extract-plugin
export var accentColor = "#ff723d";
export var categoryBorderColor = "#15ba8f";
export var disableRipple = "false";
export var mainColor = "#15ba8f";
export var mainContrast = "rgba(0,0,0,.87)";
export var panelBorderColor = "#c4c8cd";
export var secondaryColor = "#97e297";
export var secondaryContrast = "rgba(0,0,0,.87)";